import type { ApplicationListItem } from '@like-aiop/backend/src/api/applications/types';
import type { hc } from 'hono/client';
import type { AppType } from '@like-aiop/backend/src/app';

let applicationsPromise: Promise<ApplicationListItem[]> | null = null;

export const createApplicationsPromise = (
  apiClient: ReturnType<typeof hc<AppType>>
): Promise<ApplicationListItem[]> => {
  applicationsPromise ??= apiClient.applications.$get({ query: {} }).then(async res => {
    const data = await res.json();

    return data.map(item => ({
      ...item,
      birthDate: item.birthDate ? new Date(item.birthDate) : null,
      calledAt: item.calledAt ? new Date(item.calledAt) : null,
      syncedToRpmAt: item.syncedToRpmAt ? new Date(item.syncedToRpmAt) : null,
      createdAt: new Date(item.createdAt),
      updatedAt: new Date(item.updatedAt),
    }));
  });
  return applicationsPromise;
};
